import { render, staticRenderFns } from "./coach_arrears.vue?vue&type=template&id=7a2eae2a&scoped=true&"
import script from "./coach_arrears.vue?vue&type=script&lang=js&"
export * from "./coach_arrears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2eae2a",
  null
  
)

export default component.exports